
define("rv!templates/member/refer-a-friend",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:7,
          e:"h4",
          f:[ "Enter the email and name of a co-worker you would like to refer and click the submit button." ] },
        " ",
        { t:7,
          e:"h6",
          f:[ "Terms and Conditions for ",
            { t:7,
              e:"a",
              a:{ href:"#" },
              v:{ click:"onShowProgram" },
              f:[ { t:2,
                  r:"program.Name" } ] } ] },
        " ",
        { t:7,
          e:"hr" },
        " ",
        { t:4,
          f:[ { t:7,
              e:"img",
              a:{ src:"https://adestinn2blob.blob.core.windows.net/images/loading.gif",
                alt:"loading..." } } ],
          n:50,
          x:{ r:[ "program" ],
            s:"_0==null" } },
        { t:4,
          n:51,
          f:[ { t:3,
              r:"program.Rules" } ],
          x:{ r:[ "program" ],
            s:"_0==null" } } ],
      n:50,
      x:{ r:[ "qs.t" ],
        s:"_0!=null" } },
    { t:4,
      n:51,
      f:[ { t:7,
          e:"h6",
          f:[ "Enter the name and email of a co-worker you would like to refer and click the submit button." ] },
        " ",
        { t:7,
          e:"hr" },
        " ",
        { t:7,
          e:"form",
          a:{ "class":"centered-box" },
          v:{ submit:"onSubmitReferral" },
          f:[ { t:8,
              r:"messenger" },
            " ",
            { t:7,
              e:"input",
              a:{ id:"referemail",
                type:"text",
                placeholder:"Email",
                value:[ { t:2,
                    r:"email" } ] },
              v:{ keyup:"onTryExtractName",
                change:"onTryExtractName" } },
            " ",
            { t:7,
              e:"input",
              a:{ type:"text",
                id:"refername",
                placeholder:"Name",
                value:[ { t:2,
                    r:"name" } ] } },
            " ",
            { t:7,
              e:"button",
              a:{ "class":"btn btn-primary" },
              m:[ { t:4,
                  f:[ "disabled=\"disabled\"" ],
                  n:50,
                  r:"loading" } ],
              f:[ "Submit Referral" ] },
            " ",
            { t:7,
              e:"a",
              a:{ "class":"sideNote",
                href:"#" },
              v:{ click:"onShowTerms" },
              f:[ "terms and conditions" ] } ] },
        " ",
        { t:7,
          e:"br" },
        { t:7,
          e:"br" },
        " ",
        { t:7,
          e:"div",
          a:{ style:[ "display: ",
              { t:4,
                f:[ "block" ],
                n:50,
                r:"showgrid" },
              { t:4,
                n:51,
                f:[ "none" ],
                r:"showgrid" },
              " ;" ] },
          f:[ { t:7,
              e:"h6",
              f:[ "Your Referrals" ] },
            " ",
            { t:7,
              e:"table",
              a:{ id:"referrals",
                "class":"table table-bordered table-condensed" } } ] } ],
      x:{ r:[ "qs.t" ],
        s:"_0!=null" } } ] };});
